import EmblaCarousel from "embla-carousel";

export default class Viewer {
  constructor(container, controllers = {}){
    this.container = container;
    this.itemsContainer = container.querySelector('.viewer__container');
    this.items = [];
    this.currentIndex = 0;
    this.prevBtn = controllers.prev ? document.querySelector(controllers.prev) : null;
    this.nextBtn = controllers.next ? document.querySelector(controllers.next) : null;
  }

  /* USE: const emblaApi = new Carousel(viewer).init(data); */
  init(data){
    if (!this.container) return;

    data.forEach(item => {
      this.itemsContainer.appendChild(this.mountItem(item));
    });

    this.items = this.itemsContainer.querySelectorAll('.viewer__item');
    this.show(0);
    this.setupNavButtons();
    return this;
  }

  setupNavButtons() {
    this.prevHandler = () => this.prev();
    this.nextHandler = () => this.next();

    this.prevBtn?.addEventListener('click', this.prevHandler);
    this.nextBtn?.addEventListener('click', this.nextHandler);
  }

  mountItem(item) {
    const { url, alt, landscape, type, caption } = item;
    console.log(caption);
    const el = document.createElement('div');
    el.classList.add('viewer__item', landscape ? 'viewer__item--landscape' : 'viewer__item--portrait');


    let media;
    if (type === 'video') {
      media = document.createElement('video');
      media.src = url;
      media.autoplay = true;
      media.loop = true;
      media.muted = true;
      media.playsInline = true;
      media.controls = false;
      media.disablePictureInPicture = true;
    } else {
      media = document.createElement('img');
      media.src = url;
      media.alt = alt ?? '';
    }

    const media_caption = document.createElement('p');
    media_caption.innerText = caption;
    media_caption.classList.add('viewer__item__caption', 'only:xl', 'body', 'body-sm');

    el.append(media, media_caption);
    return el;
  }

  show(index) {
    this.items.forEach(item => item.classList.remove('show'));
    this.items[index].classList.add('show');
    this.currentIndex = index;
  }

  next() {
    const nextIndex = (this.currentIndex + 1) % this.items.length;
    this.show(nextIndex);
  }

  prev() {
    const prevIndex = (this.currentIndex - 1 + this.items.length) % this.items.length;
    this.show(prevIndex);
  }

  destroy() {
    this.prevBtn?.removeEventListener('click', this.prevHandler);
    this.nextBtn?.removeEventListener('click', this.nextHandler);
    this.itemsContainer.innerHTML = '';
    this.items = [];
    this.currentIndex = 0;
  }
}